/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCheckOut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h14v20H2zm6 18h2v-4H8zm4 0h2V4H4v16h2v-6h6zM8 8H6V6h2zm4 0h-2V6h2zm7.086 3.5-1.793-1.793 1.414-1.414 3.207 3.207-3.207 3.207-1.414-1.414zM8 12H6v-2h2zm4 0h-2v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCheckOut as CheckOut };
